import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Button, Col, Container, Fade, Form, Row} from 'react-bootstrap';
import {Formik} from 'formik';
import DatePicker from 'react-datepicker';
import {useTranslation} from 'react-i18next';
import {reportBookingSeries} from '../actions/partner';
import 'react-datepicker/dist/react-datepicker.css';

const endOfDayIso = value => {
  if (!value) return null;
  const date = new Date(value);
  date.setHours(23, 59, 59, 999);
  return date.toISOString();
};

export const PartnerReportBookingSeries = ({createReport}) => {
  const {t} = useTranslation();
  return (
    <Formik initialValues={{start: null, end: null}} onSubmit={createReport}>
      {({handleSubmit, setFieldValue, values}) => (
        <Fade in appear className="partner-report-skywork-content">
          <Container fluid>
            <Row className="justify-content-center">
              <Col xs={12} lg={9} xl={8}>
                <section className="partner-report-skywork-card">
                  <div className="partner-report-skywork-card-head">
                    <span className="partner-report-skywork-card-icon"><i className="fa fa-calendar-check-o"/></span>
                    <div>
                      <h2>{t('BOOKING_SERIES_REPORT_TITLE')}</h2>
                      <p>{t('BOOKING_SERIES_REPORT_HELP')}</p>
                    </div>
                  </div>
                  <Form onSubmit={handleSubmit}>
                    <Form.Row>
                      <Col>
                        <Form.Group>
                          <Form.Label>{t('START_DATE')}</Form.Label><br/>
                          <DatePicker
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            selected={values.start ? new Date(values.start) : null}
                            onChange={value => setFieldValue('start', value ? value.toISOString() : null)}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group>
                          <Form.Label>{t('END_DATE')}</Form.Label><br/>
                          <DatePicker
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            selected={values.end ? new Date(values.end) : null}
                            onChange={value => setFieldValue('end', endOfDayIso(value))}
                          />
                        </Form.Group>
                      </Col>
                    </Form.Row>
                    <Button type="submit" className="partner-report-skywork-primary">
                      <i className="fa fa-download"/> {t('EXTRACT_XLS')}
                    </Button>
                    <p className="partner-report-skywork-waiting">{t('REPORT_WAITING')}</p>
                  </Form>
                </section>
              </Col>
            </Row>
          </Container>
        </Fade>
      )}
    </Formik>
  );
};

PartnerReportBookingSeries.propTypes = {
  createReport: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  createReport: values => dispatch(reportBookingSeries(values))
});

export default withRouter(connect(null, mapDispatchToProps)(PartnerReportBookingSeries));
